import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-aria-components';
import { NavigateRoutesEnum } from '@features/routing/routesEnum';
import { Article } from '@api/types/Article';



interface GridRowProps {
	item: Article,
	rowIndex: number,
}
  

export const GridRow = (props: GridRowProps) => {
	const { rowIndex } = props;
	const { guid, name, url } = props.item;
	const { t } = useTranslation('admin');
	const navigate = useNavigate();

	const getClassName = useCallback((centered: boolean, leftAlign: boolean = false) => 
		`app-grid-cell${
			rowIndex % 2 == 0 ? ' primary-cell' : ' secondary-cell'
		}${
			leftAlign ? ' left-align-cell' : ''
		}${
			centered ? ' centered-cell' : ''
		}`
	,[ rowIndex ]);


	return (
		<>
			<div className={getClassName(true)}>
				<p>{guid ? guid : '-'}</p>
			</div>
			
			<div className={getClassName(true)}>
				<p>{name ? name : '-'}</p>
			</div>

			<div className={getClassName(true)}>
				<p>{url ? url : '-'}</p>
			</div>

			<div className={getClassName(true)}>
				<Button
					className='app-admin-button disable-selection'
					onPress={() => navigate(`${NavigateRoutesEnum.article}/${guid}`)}>
					{t('pages.articleList.editButton')}
				</Button>
			</div>
		</>
	)
}